export function getPercentage(value, total) {
    if (!total) return 0
    return Math.round((value / total) * 100)
}